import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const DashboardCallReportConfig: ReportConfigBase = {
  type: EReportTypes.DashboardCall,
  endpoint: "note",
  reportKey: "notes",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Dashboard Call Report provides detailed information about a rep's calls",
    url: "https://help.commonsku.com/knowledge/sales-dashboard-report",
  },
};

export default DashboardCallReportConfig;
